import React, {Component, PropTypes} from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

const timeouts = {
    'search-tools': [300, 300],
    'resume-autoscroll': [800, 300],
    'resume-autoscroll-rtl': [800, 300],
    tooltip: [200, 200],
    dialog: [800, 800],
};

export default class Transition extends Component {
    static propTypes = {
        name: PropTypes.oneOf(Object.keys(timeouts)).isRequired,
        className: PropTypes.string,
        style: PropTypes.object,
        children: PropTypes.node,
        disabled: PropTypes.bool,
    };

    static defaultProps = {
        className: null,
        style: null,
        children: null,
        disabled: false,
    };

    render() {
        const {name, className, style, children, disabled} = this.props;
        return (
            <ReactCSSTransitionGroup
                component='div'
                className={className}
                style={style}
                transitionName={`cielo24-vwrap-${name}`}
                transitionEnter={!disabled}
                transitionLeave={!disabled}
                transitionEnterTimeout={timeouts[name][0]}
                transitionLeaveTimeout={timeouts[name][1]}
            >
                {children}
            </ReactCSSTransitionGroup>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/utils/transition.js